import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.pedidos_api.delivery_apps;



// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// put /StartCookingOrder/<int:order_id>

export const startCookingOrder = async (orderId: string | undefined,
                                        pedidoId: number | undefined , 
                                        cookingTime: number | undefined | null,
                                        ThirdPartyProviderId: number,
                                        localId: number ) => {
  return await retryWithBackoff(() => api.put(`/StartCookingOrder/${orderId}`, {cooking_time: cookingTime,
                                                          pedido_id: pedidoId,
                                                          third_party_provider_id:  ThirdPartyProviderId,
                                                          local_id: localId
  }));
};

export const rejectOrder = async (orderId: string | undefined,
                                    pedidoId: number | undefined , 
                                    cancelType:string| undefined | null,
                                    ThirdPartyProviderId:  number) => {
    return await retryWithBackoff(() => api.put(`/RejectOrder/${orderId}`, {cancel_type: cancelType,
                                                            pedido_id: pedidoId,
                                                            third_party_provider_id:  ThirdPartyProviderId
    }));
  };

  export const OrderReady = async (orderId: string | undefined,
                                    pedidoId: number | undefined,
                                    ThirdPartyProviderId:  number,
                                    localId:number, ) => {
    return await retryWithBackoff(() => api.post(`/OrderReady/${orderId}`, {
                                                pedido_id: pedidoId,
                                                third_party_provider_id:  ThirdPartyProviderId,
                                                local_id: localId
    }));
  };



